import { render, staticRenderFns } from "./e-document-title-with-tags.vue?vue&type=template&id=11c947e4&scoped=true&lang=pug"
import script from "./e-document-title-with-tags.vue?vue&type=script&lang=js"
export * from "./e-document-title-with-tags.vue?vue&type=script&lang=js"
import style0 from "./e-document-title-with-tags.vue?vue&type=style&index=0&id=11c947e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c947e4",
  null
  
)

export default component.exports